import Image from 'next/image'
import { updateCommonReducerData } from '@/lib/reducers/commonReducer'
import { dispatch, useSelector } from '@/lib/store'

const PackageCard = ({ data }: any) => {
  const commonState = useSelector((state) => state.common) || {}

  const handleClick = () => {
    dispatch(
      updateCommonReducerData({
        ...commonState,
        requestCallbackModalIsOpen: { modalIsOpen: true, type: data.name },
      })
    )
  }

  return (
    <button
      onClick={handleClick}
      className="group flex flex-col items-center gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 rounded-lg transition-all duration-200"
    >
      <div className="relative w-[144px] h-[144px] sm:w-[170px] sm:h-[170px] md:w-[204px] md:h-[204px] rounded-lg overflow-hidden bg-gray-50 group-hover:scale-[1.02] transition-all duration-200">
        {/* Same placeholder pattern as CompleteCarePackageSection: an absent
            src renders <img src="">, which re-requests the current page URL. */}
        {data?.image ? (
          <Image
            src={data.image}
            alt={data?.name || 'Imaging test'}
            fill
            className="object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-100" />
        )}
      </div>
      <p className="capitalize text-center text-label-sm md:text-body-md font-semibold leading-tight max-w-[144px] sm:max-w-[170px] md:max-w-[204px] line-clamp-2 text-gray-900 group-hover:text-gray-950 transition-colors duration-200">
        {data?.name}
      </p>
    </button>
  )
}

export default PackageCard
